import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalModule } from './portal/portal.module';


@NgModule({
  imports: [
    CommonModule,
    PortalModule,
  ],
  declarations: [
  ]
})
export class AreaClienteModule { }



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/area-cliente.module.ts